<template>
  <div class="wrapper w-100">
    <el-table
        :data="items"
        class="w-100"
    ><el-table-column
          prop="id"
          label="ID"
          sortable
          width="80"
      ></el-table-column>
      <el-table-column
          prop="user"
          label="User"
          width="170"
          :formatter="formatUserRow"
      ></el-table-column>
      <el-table-column
          label="Brand"
          width="120"
          header-align="center"
          v-slot="{row: {brand}}"
      >
        <brand-column :brand="brand"></brand-column>
      </el-table-column>
      <el-table-column
          label="Read only"
          width="120"
          header-align="center"
          v-slot="{row: {read_only}}"
      >
        <read-only-column :read-only="read_only"></read-only-column>
      </el-table-column>
      <el-table-column
          prop="note"
          label="Note"
          v-slot="{row: {note}}"
      >
        <div class="message message-body" v-text="note"></div>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import BrandColumn from './brand-column';
import ReadOnlyColumn from './read-only-column';

export default {
  components: {
    BrandColumn,
    ReadOnlyColumn,
  },

  props: {
    items: Array,
  },

  methods: {
    /**
     * @param row
     * @param col
     * @param {Object} user
     */
    formatUserRow(row, col, user) {
      return `${user.full_name}`;
    }
  },
}
</script>
